// extracted by css-extract-rspack-plugin
export default {"PlayButton":"PlayButton-module__PlayButton__Pzuuq"};